import sessionReader from '../store/readHelpers/SessionReader';
import readinessCheckService from './ReadinessCheckService';
import standaloneTestStarter from './StandaloneTestStarter';
import apiService from './api/ApiService';
import navigationService from './NavigationService';
import alertService from './AlertService';
import timeService from './TimeService';
import { t } from './i18nService';
import candidateProgressConstants from '../constants/CandidateProgressConstants';
import parentTestService from './ParentTestService';

/**
 * Service for starting non-parent nor child tests
 */
const nonParentNorChildTestStarter = {
    /**
     * Starts a non-parent nor child test and returns a promise if applicable
     *
     * @param {Object} test - The test object containing assessmentRunId and orderNumber
     * @returns {Promise|undefined} - A promise that resolves when the test has been started (if applicable)
     */
    startNonParentNorChildTest(test) {
        const { assessmentRunId, orderNumber } = test;

        if (sessionReader.isHardwareAccessCheckEnabled()) {
            if (sessionReader.hasReadinessCheck()) {
                readinessCheckService.restoreStandaloneQuestionSet();
            }

            const startTestPromise = standaloneTestStarter.startStandaloneTest(test);

            startTestPromise
                .catch(() => {
                    alertService.showError(t('alert.livestream.startCountdownFailed'));
                })
                .then(() => {
                    // To avoid waiting for the next scheduled heartbeat in order to fetch a valid remaining-time.
                    return timeService.fetchTimeRemaining(true, true);
                });

            return startTestPromise;
        }

        if (sessionReader.hasReadinessCheck()) {
            readinessCheckService.restoreStandaloneQuestionSet();
            apiService.notifyClientEvent(candidateProgressConstants.IN_PROGRESS, '', true);
            navigationService.navigateToFirstQuestion();
            return Promise.resolve();
        }

        return parentTestService.startChildTestAndNavigate(assessmentRunId, orderNumber >= 1);
    },
};

export default nonParentNorChildTestStarter;
